export const firebaseConfig = {
  apiKey: 'AIzaSyBlFtYYmhsaOCrMM7ukv7bsYqoAIhI7Bq4',
  authDomain: 'plum-web-8eade.firebaseapp.com',
  databaseURL: 'https://plum-web-8eade.firebaseio.com',
  projectId: 'plum-web-8eade',
  storageBucket: 'plum-web-8eade.appspot.com',
  messagingSenderId: '91004350104',
  appId: '1:91004350104:web:1ad5fa75f2c26ab3456aed',
  measurementId: 'G-4QK6MVPHBW',
}
